export default __webpack_public_path__ + "static/media/foke.2ae04414.jfif";